import { render, staticRenderFns } from "./CorrespondenceThreadsList.vue?vue&type=template&id=152a157e&"
import script from "./CorrespondenceThreadsList.vue?vue&type=script&lang=js&"
export * from "./CorrespondenceThreadsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports